module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ql-cue-layer-picker-content cue-header-layer-title"
  }, [(_vm.locked || !_vm.editable) ? _c('div', {
    staticClass: "ql-button-container"
  }, [_c('div', {
    staticClass: "ql-cue-layer-picker-button ql-cue-layer-picker-static",
    style: (_vm.layerTitleStyle())
  }, [_c('md-icon', {
    style: (_vm.layerTitleIconStyle())
  }, [_vm._v("more_vert")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerBox.layerName !== false),
      expression: "headerBox.layerName !== false"
    }]
  }, [_vm._v(_vm._s(_vm.currentLayer.title))])], 1)]) : _c('md-menu', {
    ref: "layerMenu",
    attrs: {
      "md-size": "4",
      "md-close-on-select": false,
      "md-align-trigger": "",
      "md-offset-x": _vm.menuOffsetStyleX(),
      "md-offset-y": _vm.menuOffsetStyleY()
    },
    on: {
      "open": _vm.resetPageDraft,
      "close": _vm.resetPageDraft
    }
  }, [_c('md-button', {
    staticClass: "ql-cue-layer-picker-button",
    style: (_vm.layerTitleStyle()),
    attrs: {
      "md-menu-trigger": ""
    }
  }, [_c('md-icon', {
    style: (_vm.layerTitleIconStyle())
  }, [_vm._v("more_vert")]), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerBox.layerName !== false),
      expression: "headerBox.layerName !== false"
    }]
  }, [_vm._v(_vm._s(_vm.currentLayer.title))])], 1), _vm._v(" "), _c('md-menu-content', {
    staticClass: "ql-cue-menu-content"
  }, [_c('md-menu-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('span', [_vm._v("Change Layer")])]), _vm._v(" "), _vm._l((_vm.layers), function(layer) {
    return _c('md-menu-item', {
      key: layer.id,
      staticClass: "ql-cue-layer-picker-wrapper",
      on: {
        "selected": function($event) {
          return _vm.selectLayer(layer.id)
        }
      }
    }, [_c('span', {
      staticClass: "ql-cue-layer-picker",
      style: (_vm.style(layer))
    }), _vm._v(" "), _c('span', {
      staticClass: "ql-cue-layer-picker-option"
    }, [_vm._v(_vm._s(layer.title))])])
  }), _vm._v(" "), _c('md-menu-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd",
      "margin": "8px 0"
    }
  })]), _vm._v(" "), _c('md-menu-item', [_c('div', {
    staticClass: "md-list-item-container"
  }, [_c('div', {
    staticClass: "md-list-item-content"
  }, [_c('span', [_vm._v("Cue Size:")]), _vm._v(" "), _c('vue-slider', {
    attrs: {
      "min": 8,
      "max": 24
    },
    on: {
      "change": _vm.changeTitleFontSize
    },
    model: {
      value: (_vm.cueTitleFontSize),
      callback: function($$v) {
        _vm.cueTitleFontSize = $$v
      },
      expression: "cueTitleFontSize"
    }
  })], 1)])]), _vm._v(" "), _c('md-menu-item', [_c('div', {
    staticClass: "md-list-item-container"
  }, [_c('div', {
    staticClass: "md-list-item-content"
  }, [_c('span', [_vm._v("Cue Line Opacity:")]), _vm._v(" "), _c('vue-slider', {
    on: {
      "change": _vm.changeLineOpacity
    },
    model: {
      value: (_vm.cueLineOpacity),
      callback: function($$v) {
        _vm.cueLineOpacity = $$v
      },
      expression: "cueLineOpacity"
    }
  })], 1)])]), _vm._v(" "), _c('md-menu-item', {
    on: {
      "selected": function($event) {
        return _vm.restoreDefault()
      }
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#5ecfdf"
    }
  }, [_vm._v("Restore Default")])]), _vm._v(" "), _c('md-menu-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd",
      "margin": "8px 0"
    }
  })]), _vm._v(" "), _c('md-menu-item', [_c('div', {
    staticClass: "md-list-item-container"
  }, [_c('div', {
    staticClass: "md-list-item-content ql-cue-menu-list-item-content"
  }, [_c('span', [_vm._v("Cue Marker:")]), _vm._v(" "), _c('div', {
    staticClass: "md-list-item-radio-options"
  }, [_c('div', [_c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "position"
    },
    on: {
      "change": _vm.changeCueMarker
    },
    model: {
      value: (_vm.cue.type),
      callback: function($$v) {
        _vm.$set(_vm.cue, "type", $$v)
      },
      expression: "cue.type"
    }
  }, [_vm._v(" Line")])], 1), _vm._v(" "), _c('div', [_c('md-radio', {
    staticClass: "md-primary",
    attrs: {
      "mdValue": "selection"
    },
    on: {
      "change": _vm.changeCueMarker
    },
    model: {
      value: (_vm.cue.type),
      callback: function($$v) {
        _vm.$set(_vm.cue, "type", $$v)
      },
      expression: "cue.type"
    }
  }, [_vm._v(" Resizable Box")])], 1)]), _vm._v(" "), (_vm.cue.type === 'selection') ? _c('div', [_c('span', [_vm._v("Cue Box Opacity:")]), _vm._v(" "), _c('vue-slider', {
    on: {
      "change": _vm.changeBoxOpacity
    },
    model: {
      value: (_vm.cueBoxOpacity),
      callback: function($$v) {
        _vm.cueBoxOpacity = $$v
      },
      expression: "cueBoxOpacity"
    }
  })], 1) : _vm._e()])])]), _vm._v(" "), _c('md-menu-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd",
      "margin": "8px 0"
    }
  })]), _vm._v(" "), _c('md-menu-item', [_c('div', {
    staticClass: "md-list-item-container"
  }, [_c('div', {
    staticClass: "md-list-item-content ql-cue-menu-list-item-content"
  }, [_c('span', [_vm._v("Visible in cue:")]), _vm._v(" "), _c('div', {
    staticClass: "md-list-item-radio-options"
  }, [_c('div', {
    staticClass: "headerBoxOption",
    class: {
      'headerBoxOptionMarked': _vm.headerBox.title
    },
    on: {
      "click": _vm.changeHeaderBoxTitle
    }
  }, [_c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.headerBox.title),
      expression: "!headerBox.title"
    }]
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerBox.title),
      expression: "headerBox.title"
    }]
  }, [_vm._v("check_box")]), _vm._v(" "), _c('span', [_vm._v("Number/Title")])], 1), _vm._v(" "), _c('div', {
    staticClass: "headerBoxOption",
    class: {
      'headerBoxOptionMarked': _vm.headerBox.label
    },
    on: {
      "click": _vm.changeHeaderBoxLabel
    }
  }, [_c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.headerBox.label),
      expression: "!headerBox.label"
    }]
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerBox.label),
      expression: "headerBox.label"
    }]
  }, [_vm._v("check_box")]), _vm._v(" "), _c('span', [_vm._v("Label")])], 1), _vm._v(" "), _c('div', {
    staticClass: "headerBoxOption",
    class: {
      'headerBoxOptionMarked': _vm.headerBox.time
    },
    on: {
      "click": _vm.changeHeaderBoxTime
    }
  }, [_c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.headerBox.time),
      expression: "!headerBox.time"
    }]
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('md-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerBox.time),
      expression: "headerBox.time"
    }]
  }, [_vm._v("check_box")]), _vm._v(" "), _c('span', [_vm._v("Time")])], 1)])])])]), _vm._v(" "), _c('md-menu-item', {
    attrs: {
      "disabled": ""
    }
  }, [_c('span', [_vm._v("Change Page:")])]), _vm._v(" "), _c('md-menu-item', [_c('div', {
    staticClass: "md-list-item-container"
  }, [_c('div', {
    staticClass: "md-list-item-content",
    staticStyle: {
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-raised md-dense",
    attrs: {
      "disabled": !_vm.canPageDown
    },
    on: {
      "click": _vm.pageDown
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "page-number-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageDraft),
      expression: "pageDraft"
    }],
    ref: "input_page_number",
    staticClass: "input_page_number",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pageDraft)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.change_page.apply(null, arguments)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.pageDraft = $event.target.value
      }, function($event) {
        _vm.pageError = ''
      }],
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        return _vm.ignoreKeydown.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        return _vm.ignoreKeydown.apply(null, arguments)
      }]
    }
  }), _vm._v("\n                                    / " + _vm._s(_vm.lastPageLabel) + "\n                            ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button md-raised md-dense",
    attrs: {
      "disabled": !_vm.canPageUp
    },
    on: {
      "click": _vm.pageUp
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_right")])], 1)], 1), _vm._v(" "), (_vm.pageError) ? _c('span', {
    staticClass: "page-number-error"
  }, [_vm._v(_vm._s(_vm.pageError))]) : _vm._e()])])]), _vm._v(" "), _c('md-menu-item', {
    on: {
      "selected": function($event) {
        return _vm.deleteCueMarker()
      }
    }
  }, [_c('md-icon', [_vm._v("delete")]), _c('span', [_vm._v("Delete Cue")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65f4cd2c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/cues/layer-picker.vue
// module id = 1254
// module chunks = 21